(function () {
  var h = document.querySelector('.section-header');
  if (!h) return;
  function onScroll() {
    h.classList.toggle('ns-scrolled', window.scrollY > 80);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

/* Banner clicável - usa o "Link do botão" de cada slide */
  document.querySelectorAll('.slideshow__slide').forEach(function (slide) {
    var url = slide.getAttribute('data-ns-link');
    if (!url) return;                 // slide sem link configurado: ignora
    slide.style.cursor = 'pointer';
    slide.addEventListener('click', function (e) {
      /* não sequestra cliques em botões/links reais dentro do slide */
      if (e.target.closest('a, button')) return;
      window.location.href = url;
    });
  });
})();

/* ============================================
   GALERIA PRODUTO — carrossel de miniaturas
   O tema não atualiza a miniatura ativa ao usar
   as setas da imagem principal. Este bloco escuta
   o scroll do slider principal, calcula o slide
   visível e: (1) marca a miniatura correspondente
   (aria-current, que recebe o destaque do tema);
   (2) rola a coluna para centralizá-la.
   ============================================ */
(function () {
  function initGallerySync() {
    document.querySelectorAll('media-gallery').forEach(function (mg) {
      var viewerComp = mg.querySelector('slider-component:not(.thumbnail-slider)');
      var viewerUl = viewerComp && viewerComp.querySelector('.slider');
      var list = mg.querySelector('.thumbnail-list');
      if (!viewerUl || !list || viewerUl.dataset.nsSync) return;
      viewerUl.dataset.nsSync = '1';

      var timer = null;

      function sync() {
        if (!window.matchMedia('(min-width: 600px)').matches) return;
        var slides = viewerUl.querySelectorAll(':scope > li');
        if (!slides.length) return;
        /* passo real entre slides = largura + gap */
        var step = slides.length > 1
          ? slides[1].offsetLeft - slides[0].offsetLeft
          : slides[0].offsetWidth;
        var idx = Math.round(viewerUl.scrollLeft / step);
        idx = Math.min(slides.length - 1, Math.max(0, idx));
        var items = list.querySelectorAll(':scope > li');
        if (!items[idx]) return;
        /* destaque na miniatura ativa */
        items.forEach(function (li, i) {
          var btn = li.querySelector('.thumbnail');
          if (!btn) return;
          if (i === idx) btn.setAttribute('aria-current', 'true');
          else btn.removeAttribute('aria-current');
        });
        /* centraliza a ativa dentro da coluna (sem mover a página) */
        var item = items[idx];
        var target = item.offsetTop - (list.clientHeight - item.offsetHeight) / 2;
        list.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
      }

      viewerUl.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(sync, 150);
      }, { passive: true });

      sync();
    });
  }

  initGallerySync();

  /* re-inicializa se o Shopify re-renderizar a galeria
     (troca de variante / editor de tema) */
  var wrapper = document.querySelector('.product__media-wrapper');
  if (wrapper) {
    var reinitTimer = null;
    new MutationObserver(function () {
      clearTimeout(reinitTimer);
      reinitTimer = setTimeout(initGallerySync, 300);
    }).observe(wrapper, { childList: true, subtree: true });
  }
})();